export default function WaitingAgent({ waitingAgentCheck, hangupCall }: { waitingAgentCheck: boolean, hangupCall: () => void; }) {


    if (waitingAgentCheck) {
        return (
            <section className="px-4 py-10 flex flex-col items-center justify-center text-center">
                <h3 className="text-2xl font-bold text-purple-900 mb-2">
                    {"Venter på at agenten skal motta samtalen"}
                </h3>
                <div className="animate-pulse text-purple-600 font-medium">
                    {"Venter på å bli akseptert..."}
                </div>
                <button onClick={hangupCall} className="mt-6 bg-red-500 text-white px-4 py-2 rounded-full">{"Avslutt samtale"}</button>
            </section>
        )
    }
}